<template>
  <div>
    <homelogo />
    <v-img src="@/assets/Reacondicionar/Reacondicionarte_banner_superior.jpg">
    <h1 class="titlesRecondition px-10">
          Reacondicionarte
        </h1>
    </v-img>
    <v-row>
      <v-col cols="12" lg="4" md="4" sm="12">
        <h1 class="text-center titlesCenter px-10">
          BUENAS
          PRÁCTICAS
        </h1>
      </v-col>
      <v-col cols="12" lg="8" md="8" sm="12">
        <p class="parrafos1 px-10 text-center">
          A través de este proyecto nuestra fundación resalta la importancia del 
          reciclaje responsable, promocionando la restauración, reparación y 
          aprovechamiento de cada residuo electrónico que la sociedad genera.
          <!-- La empresa Pcshek promocionando las buenas prácticas en reciclaje elec-
          trónico responsable: restaura, repara y aprovecha cada residuo electrónico,
          fomentando la reutilización y el reciclaje dando un cambio al modelo tradi-
          cional y aportando al impacto ambiental que genera la industria tradicional. -->
          <br />
          <br />Con este proyecto niños entre los 0 y 9 años de edad se verán beneficiados
          de manera directa con productos restaurados donados por nuestra
          fundación. Gracias a esta nueva cadena de valor nuestras donaciones
          serán utilizadas por familias y entidades que protejen a esta población.
        </p>
      </v-col>
    </v-row>
    <v-img src="@/assets/Reacondicionar/Reacondicionarte_parrafo_1.jpg"></v-img>
    <br />
    <v-row>
      <v-col cols="12" lg="6" md="6" sm="12" class="box-center">
        <p class="parrafos1 px-10 text-center">
          Brindamos recursos tecnológicos que mejoran la calidad
          de vida y bienestar de niños y familias, quienes podrán
          gozar de una buena educación, un mejor sistema de
          salud o proyectos sociales y recreativos necesarios para
          un mejor desarrollo como individuos.
        </p>
      </v-col>
      <v-col cols="12" lg="6" md="6" sm="12">
        <v-img src="@/assets/Reacondicionar/Reacondicionamiento.png"></v-img>
      </v-col>
    </v-row>
    <v-img src="@/assets/Reacondicionar/Reacondicionarte.png"></v-img>
    <br />
    <br />
    <h1 class="text-center titlesCenter px-10">Reacondicionar es un arte</h1>
    <br />
    <v-card max-width="75%" max-height="50%" class="mx-auto">
      <v-carousel :show-arrows="true" hide-delimiters height="auto" cycle>
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="i"
          class="white--text text-center"
        >
          <v-img class="align-end" aspect-ratio="1.77" contain :src="require(`@/assets/Reacondicionar/${slide.img}.jpg`)">
            <v-card color="rgb(0, 0, 0, 0.3)">
              <p class="white--text text-center parrafosSub">{{slide.text}}</p>
            </v-card>
          </v-img>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    <v-row>
      <v-col cols="12" lg="6" md="6" sm="12">
        <v-img src="@/assets/Reacondicionar/imagen_parrafo_3.jpg"></v-img>
      </v-col>
      <v-col cols="12" lg="6" md="6" sm="12" class="box-center">
        <p class="parrafos1 px-10 text-center">
          El arte de transformar los Residuos Electrónicos en
          nuevas creaciones, como obras de arte, joyería,
          bisutería, aparatos reacondicionados, Robótica, son
          algunas de las iniciativas creativas que algunos
          hemos visionado y llevado a la realidad.
          La transformación de Residuos electrónicos a
          Recursos útiles contribuye en la disminución de
          desechos sanitarios, preserva el medio ambiente y
          beneficia a quienes acceden a estos recursos.
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import homelogo from "@/components/homelogo/homelogo.vue";

export default {
  components: {
    homelogo
  },
  data: () => ({
    slides: [
      {
        img: "carrusel_1",
        text:
          "Vik Muñiz. 2008. El nacimiento de Venus, después de Botticelli (Pictures of Junk)."
      },
      { img: "carrusel_2", text: "Nick Gentry. 2011. The Inmortal." },
      { img: "carrusel_3", text: "Anthony Heywood. 2004. Mother elephant." },
      { img: "carrusel_4", text: "fuente: https://9gag.com/gag/avg8Eon" },
      { img: "carrusel_5", text: "fuente: www.therecomputing.com" }
    ]
  }),
  methods: {
    onclickreturn() {
      this.$vuetify.goTo("#nosotros");
    }
  }
};
</script>
<style scoped>
.imglogo {
  position: absolute;
  width: 20%;
  z-index: 99;
}
.v-btn {
  text-transform: none !important;
}
.alignEnd {
  justify-content: flex-end;
}
.caja {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  background: #333944;
}
.box {
  width: 100%;
}
.imgSize {
    max-width:100%; 
    max-height:100%; 
    vertical-align: middle; 
}

.centerButtons {
  margin: 0;
  margin-top: 50%;
}
</style>